import { defineComponent as _defineComponent } from 'vue';
import { createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode } from "vue";
const _hoisted_1 = { class: "integration-skeleton" };
const _hoisted_2 = { class: "integration-skeleton__connector" };
const _hoisted_3 = { class: "integration-skeleton__item__figure" };
const _hoisted_4 = { class: "integration-skeleton__item__fields" };
const _hoisted_5 = { class: "integration-skeleton__item__group" };
const _hoisted_6 = { class: "integration-skeleton__item__group" };
import SkeletonLoader from '@/components/_atoms/SkeletonLoader.vue';
export default /*#__PURE__*/ _defineComponent({
    __name: 'AudienceIntegrationSkeleton',
    setup(__props) {
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createVNode(SkeletonLoader, {
                    height: "20px",
                    width: "219px",
                    class: "mb-2"
                }),
                _createElementVNode("div", _hoisted_2, [
                    (_openBlock(), _createElementBlock(_Fragment, null, _renderList([1, 2, 3, 4], (index) => {
                        return _createElementVNode("div", {
                            class: "integration-skeleton__item",
                            key: index
                        }, [
                            _createElementVNode("div", _hoisted_3, [
                                _createVNode(SkeletonLoader, {
                                    height: "46px",
                                    width: "81px"
                                })
                            ]),
                            _createElementVNode("div", _hoisted_4, [
                                _createElementVNode("div", _hoisted_5, [
                                    _createVNode(SkeletonLoader, {
                                        height: "11px",
                                        width: "69px",
                                        class: "d-block mb-2"
                                    }),
                                    _createVNode(SkeletonLoader, { width: "207px" })
                                ]),
                                _createElementVNode("div", _hoisted_6, [
                                    _createVNode(SkeletonLoader, {
                                        height: "11px",
                                        width: "69px",
                                        class: "d-block mb-2"
                                    }),
                                    _createVNode(SkeletonLoader, { width: "207px" })
                                ]),
                                _createVNode(SkeletonLoader, { width: "207px" })
                            ]),
                            _createVNode(SkeletonLoader, { width: "181px" })
                        ]);
                    }), 64))
                ])
            ]));
        };
    }
});
